// extracted by mini-css-extract-plugin
export default {"container":"Security_container__FnvZO","form":"Security_form__3sgwM","submitBtn":"Security_submitBtn__lopX0"};